<div class="settings-item !items-start">
    <div class="heading-wrapper">
        <div class="description">
            <div class="settings-header">
                <div class="with-label">
                    Compounding
                    <app-badge [color]="BadgeColorsEnum.Green">beta</app-badge>
                </div>
            </div>
            <div class="settings-sub-header">
                Accurately track compounds and the controlled substances used to compound.
            </div>
        </div>
    </div>
    <div class="controls">
        <div class="switch" (click)="onSwitchClick()">
            <img class="toggle-switch" [class.hidden]="compoundingEnabled$ | async" src="assets/icons/icon-slide-switch-is-off.svg"
                alt="off" title="off" />
            <img class="toggle-switch" [class.hidden]="!(compoundingEnabled$ | async)" src="assets/icons/icon-slide-switch-is-on.svg"
                alt="on" title="on" />
        </div>
    </div>
</div>
